// importing react componet
import * as React from 'react';

// importing react-redux component
import { connect } from 'react-redux';

// imoprting routing component
import { Link } from 'react-router-dom';

// logout
import { logout } from '../../store/login/action'

// header
import Header from '../../sharedcomponents/header';

// loading
import { Loader } from '../../sharedcomponents/loader';

// actions
import { fetchEnclosurePOBegin } from '../../store/enclosurePO/actions'

// importing enclosure grid
import EnclosurePOReportGrid from './enclosurePOReportGrid';

// class
class enclosurePO extends React.PureComponent<any, any>  {
  public changeCurrentPage: any; public changePageSize: any;

  // initializing constructor
  constructor(props: any) {
    super(props);

    // initializing state
    this.state = {
      route: '',
      date: '',
      selectedReport: 'All',
      projectsDeliveredStatus: "inProgress",
      rows: [],
      inProgressGrid: true,
      inProgressRows: [],
      inProgressColumn: [],
      deliveredGrid: true,
      deliveredRows: [],
      deliveredColumn: [],
      sorting: [{ columnName: 'UserName', direction: 'asc' }],
      totalCount: 0,
      pageSize: 10,
      pageSizes: [10, 15, 30, 50],
      dateFilterOperations: ['month', 'day', 'year', 'contains', 'startsWith', 'endsWith'],
    };

    // binding public fuction to this
    this.changeCurrentPage = (currentPage: any) => this.setState({ currentPage });
    this.changePageSize = (pageSize: any) => this.setState({ pageSize });
  }

  public componentWillMount() {
    const route = location.hash;
    const getCurrentRoute = route.toString().split("/");
    this.setState({
      selectedReport: `${getCurrentRoute[1]}`,
      selectedFilter: `${getCurrentRoute[2]}`
    })
    this.props.dispatch(fetchEnclosurePOBegin(getCurrentRoute[2]))
  }

  public componentWillReceiveProps(props: any) {
    if (props.InProgress) {
      this.setState({
        inProgressRows: props.InProgress,
        inProgressColumn: [
          { name: 'prop_num', title: 'PropNum'},
          { name: 'client_reference', title: 'Client Name'},
          { name: 'vendor', title: 'Vendor Job#'},
          { name: 'deposit_received', title: 'Deposit Recieved'},
          { name: 'outfor_approval', title: 'Status'},
          { name: 'salesperson', title: 'SR'},
          { name: 'product', title: 'Product'},
          { name: 'quantity', title: 'Qty'},
          { name: 'finish', title: 'Finish'},
          { name: 'date_needed', title: 'Due Date'}
        ],
      })
    }

    if (props.Delivered) {
      this.setState({
        deliveredRows: props.Delivered,
        deliveredColumn: [
          { name: 'prop_num', title: 'PropNum' },
          { name: 'client_reference', title: 'Client Name' },
          { name: 'dsponum', title: 'PO' },
          { name: 'ven_job_num', title: 'Vendor Job#' },
          { name: 'vendor', title: 'Vendor' },
          { name: 'salesperson', title: 'SR' },
          { name: 'product', title: 'Product' },
          { name: 'quantity', title: 'Qty' },
          { name: 'finish', title: 'Finish' },
          { name: 'cost', title: 'Cost' }
        ],
      })
    }
  }

  public Sessionlogout() {
    this.props.dispatch(logout());
  }

  public getFileteredParams(event: any) {
    this.setState({
      selectedFilter: event.target.value
    })
    if (event.target.value) {
      this.props.dispatch(fetchEnclosurePOBegin(event.target.value));
    }
  }

  public render() {
    const loading = this.props.loading ? <Loader /> : '';
    const { path } = this.props.match;

    return (

      <div>
        {loading}
        <Header />
        <div className="header-bottom">
          <button
            className="btn right-float"
            onClick={() => this.Sessionlogout()}
          >Logout</button>
        </div>
        <div className="content-body">
          <div className="production-filter">
            <select onChange={(e) => {
              this.getFileteredParams(e)

            }} value={this.state.selectedFilter} >
              <option value="All">All</option>
              <option value="coloSign">Colo Sign</option>
              <option value="kenRay">KenRay</option>
              <option value="boydSigns">Boyd Signs</option>
              <option value="temporary"> Temporary</option>
              <option value="allDelivered"> All Delivered</option>
            </select>
            <ul>
              <li className={this.state.inProgressGrid ? "active" : ''}
                onClick={
                  (e) => {
                    const gridStatus = this.state.inProgressGrid ? false : true
                    this.setState({ inProgressGrid: gridStatus })
                  }
                }>
                <Link to={`${path}/${this.state.selectedFilter}`}>
                  In Progress
                </Link>
              </li>
              <li className={this.state.deliveredGrid ? "active" : ''}
                onClick={
                  (e) => {
                    const gridStatus = this.state.deliveredGrid ? false : true
                    this.setState({ deliveredGrid: gridStatus })
                  }
                }>
                <Link to={`${path}/${this.state.selectedFilter}`}>
                  Delivered
                </Link>
              </li>
            </ul>

          </div>

          <div className="content-section" id="enclosure-report">
            <div className="grid-style">
              {this.state.inProgressGrid ? (
                <EnclosurePOReportGrid
                  tablecolor="#00bb00"
                  rows={this.props.InProgress || []}
                  columns={this.state.inProgressColumn}
                />
              ) : ""
              }
              <br />
              {
                this.state.deliveredGrid ? (
                  <EnclosurePOReportGrid
                    tablecolor="#f0e400"
                    rows={this.props.Delivered || []}
                    columns={this.state.deliveredColumn}
                  />
                ) : ""
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// mapping all the recieved prop to local
const mapStateToProps = (state: any) => ({
  InProgress: state.enclosurePO.InProgress,
  Delivered: state.enclosurePO.Delivered,
  loading: state.loading.getenclosurePOStatus
});
export default connect(mapStateToProps)(enclosurePO);



// WEBPACK FOOTER //
// ./src/components/Enclosure PO/enclosurePO.tsx